// Action Type for opportunities

// Search Single Customer Opportunities List Action Type
export const SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST =
  "SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST";
export const SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_SUCCESS =
  "SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_SUCCESS";
export const SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_FAIL =
  "SEARCH_SINGLE_CUSTOMER_OPPORTUNITIES_LIST_FAIL";

// Create Opportunities Item Action Type
export const CREATE_OPPORTUNITIES_ITEM = "CREATE_OPPORTUNITIES_ITEM";
export const CREATE_OPPORTUNITIES_ITEM_SUCCESS =
  "CREATE_OPPORTUNITIES_ITEM_SUCCESS";
export const CREATE_OPPORTUNITIES_ITEM_FAIL = "CREATE_OPPORTUNITIES_ITEM_FAIL";

// Update Opportunities Item Action Type
export const UPDATE_OPPORTUNITIES_ITEM = "UPDATE_OPPORTUNITIES_ITEM";
export const UPDATE_OPPORTUNITIES_ITEM_SUCCESS =
  "UPDATE_OPPORTUNITIES_ITEM_SUCCESS";
export const UPDATE_OPPORTUNITIES_ITEM_FAIL = "UPDATE_OPPORTUNITIES_ITEM_FAIL";

// Get All Opportunities List Action Type
export const GET_ALL_OPPORTUNITIES_LIST = "GET_ALL_OPPORTUNITIES_LIST";
export const GET_ALL_OPPORTUNITIES_LIST_SUCCESS =
  "GET_ALL_OPPORTUNITIES_LIST_SUCCESS";
export const GET_ALL_OPPORTUNITIES_LIST_FAIL =
  "GET_ALL_OPPORTUNITIES_LIST_FAIL";

// Get Single Opportunities Item Action Type
export const GET_SINGLE_OPPORTUNITIES_ITEM = "GET_SINGLE_OPPORTUNITIES_ITEM";
export const GET_SINGLE_OPPORTUNITIES_ITEM_SUCCESS =
  "GET_SINGLE_OPPORTUNITIES_ITEM_SUCCESS";
export const GET_SINGLE_OPPORTUNITIES_ITEM_FAIL =
  "GET_SINGLE_OPPORTUNITIES_ITEM_FAIL";

// Delete Opportunities Item Action Type
export const DELETE_OPPORTUNITIES_ITEM = "DELETE_OPPORTUNITIES_ITEM";
export const DELETE_OPPORTUNITIES_ITEM_SUCCESS =
  "DELETE_OPPORTUNITIES_ITEM_SUCCESS";
export const DELETE_OPPORTUNITIES_ITEM_FAIL = "DELETE_OPPORTUNITIES_ITEM_FAIL";

// Opportunities Status List Action Type
export const OPPORTUNITIES_STATUS_LIST = "OPPORTUNITIES_STATUS_LIST";
export const OPPORTUNITIES_STATUS_LIST_SUCCESS =
  "OPPORTUNITIES_STATUS_LIST_SUCCESS";
export const OPPORTUNITIES_STATUS_LIST_FAIL = "OPPORTUNITIES_STATUS_LIST_FAIL";

// Opportunities Priority List Action Type
export const OPPORTUNITIES_PRIORITY_LIST = "OPPORTUNITIES_PRIORITY_LIST";
export const OPPORTUNITIES_PRIORITY_LIST_SUCCESS =
  "OPPORTUNITIES_PRIORITY_LIST_SUCCESS";
export const OPPORTUNITIES_PRIORITY_LIST_FAIL =
  "OPPORTUNITIES_PRIORITY_LIST_FAIL";

// Opportunities Type List Action Type
export const OPPORTUNITIES_TYPE_LIST = "OPPORTUNITIES_TYPE_LIST";
export const OPPORTUNITIES_TYPE_LIST_SUCCESS =
  "OPPORTUNITIES_TYPE_LIST_SUCCESS";
export const OPPORTUNITIES_TYPE_LIST_FAIL = "OPPORTUNITIES_TYPE_LIST_FAIL";

// Get Single Opportunity data Action Type
export const GET_SINGLE_OPPORTUNITY_DATA = "GET_SINGLE_OPPORTUNITY_DATA";
export const GET_SINGLE_OPPORTUNITY_DATA_SUCCESS =
  "GET_SINGLE_OPPORTUNITY_DATA_SUCCESS";
export const GET_SINGLE_OPPORTUNITY_DATA_FAIL =
  "GET_SINGLE_OPPORTUNITY_DATA_FAIL";

// Search Opportunity Note List Action Type
export const SEARCH_OPPORTUNITY_NOTE_LIST = "SEARCH_OPPORTUNITY_NOTE_LIST";
export const SEARCH_OPPORTUNITY_NOTE_LIST_SUCCESS =
  "SEARCH_OPPORTUNITY_NOTE_LIST_SUCCESS";
export const SEARCH_OPPORTUNITY_NOTE_LIST_FAIL =
  "SEARCH_OPPORTUNITY_NOTE_LIST_FAIL";

// Create Opportunity Note Item Action Type
export const CREATE_OPPORTUNITY_NOTE_ITEM = "CREATE_OPPORTUNITY_NOTE_ITEM";
export const CREATE_OPPORTUNITY_NOTE_ITEM_SUCCESS =
  "CREATE_OPPORTUNITY_NOTE_ITEM_SUCCESS";
export const CREATE_OPPORTUNITY_NOTE_ITEM_FAIL =
  "CREATE_OPPORTUNITY_NOTE_ITEM_FAIL";

// Single Opportunity Activity List
export const SINGLE_OPPORTUNITY_ACTIVITY_LIST =
  "SINGLE_OPPORTUNITY_ACTIVITY_LIST";
export const SINGLE_OPPORTUNITY_ACTIVITY_LIST_SUCCESS =
  "SINGLE_OPPORTUNITY_ACTIVITY_LIST_SUCCESS";
export const SINGLE_OPPORTUNITY_ACTIVITY_LIST_FAIL =
  "SINGLE_OPPORTUNITY_ACTIVITY_LIST_FAIL";

// Add New Opportunity Status
export const ADD_NEW_OPPORTUNITY_STATUS = "ADD_NEW_OPPORTUNITY_STATUS";
export const ADD_NEW_OPPORTUNITY_STATUS_SUCCESS =
  "ADD_NEW_OPPORTUNITY_STATUS_SUCCESS";
export const ADD_NEW_OPPORTUNITY_STATUS_FAIL =
  "ADD_NEW_OPPORTUNITY_STATUS_FAIL";

// Delete Opportunity Status
export const DELETE_OPPORTUNITY_STATUS = "DELETE_OPPORTUNITY_STATUS";
export const DELETE_OPPORTUNITY_STATUS_SUCCESS =
  "DELETE_OPPORTUNITY_STATUS_SUCCESS";
export const DELETE_OPPORTUNITY_STATUS_FAIL = "DELETE_OPPORTUNITY_STATUS_FAIL";

// Update Opportunity Status
export const UPDATE_OPPORTUNITY_STATUS = "UPDATE_OPPORTUNITY_STATUS";
export const UPDATE_OPPORTUNITY_STATUS_SUCCESS =
  "UPDATE_OPPORTUNITY_STATUS_SUCCESS";
export const UPDATE_OPPORTUNITY_STATUS_FAIL = "UPDATE_OPPORTUNITY_STATUS_FAIL";

// Add New Opportunity Priority
export const ADD_NEW_OPPORTUNITY_PRIORITY = "ADD_NEW_OPPORTUNITY_PRIORITY";
export const ADD_NEW_OPPORTUNITY_PRIORITY_SUCCESS =
  "ADD_NEW_OPPORTUNITY_PRIORITY_SUCCESS";
export const ADD_NEW_OPPORTUNITY_PRIORITY_FAIL =
  "ADD_NEW_OPPORTUNITY_PRIORITY_FAIL";

// Delete Opportunity Priority
export const DELETE_OPPORTUNITY_PRIORITY = "DELETE_OPPORTUNITY_PRIORITY";
export const DELETE_OPPORTUNITY_PRIORITY_SUCCESS =
  "DELETE_OPPORTUNITY_PRIORITY_SUCCESS";
export const DELETE_OPPORTUNITY_PRIORITY_FAIL =
  "DELETE_OPPORTUNITY_PRIORITY_FAIL";

// Update Opportunity Priority
export const UPDATE_OPPORTUNITY_PRIORITY = "UPDATE_OPPORTUNITY_PRIORITY";
export const UPDATE_OPPORTUNITY_PRIORITY_SUCCESS =
  "UPDATE_OPPORTUNITY_PRIORITY_SUCCESS";
export const UPDATE_OPPORTUNITY_PRIORITY_FAIL =
  "UPDATE_OPPORTUNITY_PRIORITY_FAIL";

// Add New Opportunity Type
export const ADD_NEW_OPPORTUNITY_TYPE = "ADD_NEW_OPPORTUNITY_TYPE";
export const ADD_NEW_OPPORTUNITY_TYPE_SUCCESS =
  "ADD_NEW_OPPORTUNITY_TYPE_SUCCESS";
export const ADD_NEW_OPPORTUNITY_TYPE_FAIL = "ADD_NEW_OPPORTUNITY_TYPE_FAIL";

// Delete Opportunity Type
export const DELETE_OPPORTUNITY_TYPE = "DELETE_OPPORTUNITY_TYPE";
export const DELETE_OPPORTUNITY_TYPE_SUCCESS =
  "DELETE_OPPORTUNITY_TYPE_SUCCESS";
export const DELETE_OPPORTUNITY_TYPE_FAIL = "DELETE_OPPORTUNITY_TYPE_FAIL";

// Update Opportunity Type
export const UPDATE_OPPORTUNITY_TYPE = "UPDATE_OPPORTUNITY_TYPE";
export const UPDATE_OPPORTUNITY_TYPE_SUCCESS =
  "UPDATE_OPPORTUNITY_TYPE_SUCCESS";
export const UPDATE_OPPORTUNITY_TYPE_FAIL = "UPDATE_OPPORTUNITY_TYPE_FAIL";

///opportunity/overview/funnel
// Get Opportunity Overview Funnel Data
export const GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA =
  "GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA";
export const GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_SUCCESS =
  "GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_SUCCESS";
export const GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_FAIL =
  "GET_OPPORTUNITY_OVERVIEW_FUNNEL_DATA_FAIL";

// Search Opportunity Attachment List
export const SEARCH_OPPORTUNITY_ATTACHMENT_LIST =
  "SEARCH_OPPORTUNITY_ATTACHMENT_LIST";
export const SEARCH_OPPORTUNITY_ATTACHMENT_LIST_SUCCESS =
  "SEARCH_OPPORTUNITY_ATTACHMENT_LIST_SUCCESS";
export const SEARCH_OPPORTUNITY_ATTACHMENT_LIST_FAIL =
  "SEARCH_OPPORTUNITY_ATTACHMENT_LIST_FAIL";

// Delete Opportunity Attachment
export const DELETE_OPPORTUNITY_ATTACHMENT = "DELETE_OPPORTUNITY_ATTACHMENT";
export const DELETE_OPPORTUNITY_ATTACHMENT_SUCCESS =
  "DELETE_OPPORTUNITY_ATTACHMENT_SUCCESS";
export const DELETE_OPPORTUNITY_ATTACHMENT_FAIL =
  "DELETE_OPPORTUNITY_ATTACHMENT_FAIL";

// Search Opportunity Product (interested products) List Action Type
export const SEARCH_OPPORTUNITY_PRODUCT_LIST =
  "SEARCH_OPPORTUNITY_PRODUCT_LIST";
export const SEARCH_OPPORTUNITY_PRODUCT_LIST_SUCCESS =
  "SEARCH_OPPORTUNITY_PRODUCT_LIST_SUCCESS";
export const SEARCH_OPPORTUNITY_PRODUCT_LIST_FAIL =
  "SEARCH_OPPORTUNITY_PRODUCT_LIST_FAIL";

// Create Opportunity Product Item Action Type
export const CREATE_OPPORTUNITY_PRODUCT_ITEM =
  "CREATE_OPPORTUNITY_PRODUCT_ITEM";
export const CREATE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS =
  "CREATE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS";
export const CREATE_OPPORTUNITY_PRODUCT_ITEM_FAIL =
  "CREATE_OPPORTUNITY_PRODUCT_ITEM_FAIL";

// Delete Opportunity Product Item Action Type
export const DELETE_OPPORTUNITY_PRODUCT_ITEM =
  "DELETE_OPPORTUNITY_PRODUCT_ITEM";
export const DELETE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS =
  "DELETE_OPPORTUNITY_PRODUCT_ITEM_SUCCESS";
export const DELETE_OPPORTUNITY_PRODUCT_ITEM_FAIL =
  "DELETE_OPPORTUNITY_PRODUCT_ITEM_FAIL";
